import OngoingIcon from "@/Svgs/States/OngoingIcon.svg.vue";
import SupervisionIcon from "@/Svgs/States/SupervisionIcon.svg.vue";
import ConflictingIcon from "@/Svgs/States/ConflictingIcon.svg.vue";
import ValidatedIcon from "@/Svgs/States/ValidatedIcon.svg.vue";

export const statesEvaluation = {
    ongoing: {
        component: OngoingIcon,
        class: '-is-ongoing',
        title: 'En cours',
        value: 'Ongoing',
        order: 1,
        nextStatus: 'supervision'
    },
    supervision: {
        component: SupervisionIcon,
        class: '-is-supervision',
        title: 'Supervision',
        value: 'Supervision',
        order: 2,
        nextStatus: 'contradictory'
    },
    contradictory: {
        component: ConflictingIcon,
        class: '-is-conflicting',
        title: 'Contradictoire',
        value: 'Contradictory',
        order: 3,
        nextStatus: 'validated'
    },
    validated: {
        component: ValidatedIcon,
        class: '-is-validated',
        title: 'Validée',
        value: 'Validated',
        order: 4,
        nextStatus: null
    },
};
